export default __webpack_public_path__ + "static/media/tour2.2bd086f0.png";